import * as React from "react";
import { Checkbox } from "@/components/ui/checkbox";
import { Label } from "@/components/ui/label";

interface RememberMeCheckboxProps {
  checked: boolean;
  onCheckedChange: (checked: boolean) => void;
  id?: string;
  /** Checkbox label — pass a translated string from the parent. */
  label?: string;
}

/**
 * Remember Me Checkbox Component
 *
 * Checkbox for "Remember me" option in login form.
 */
export function RememberMeCheckbox({
  checked,
  onCheckedChange,
  id = "remember-me",
  label = "Remember me",
}: RememberMeCheckboxProps) {
  return (
    <div className="flex items-center space-x-2">
      <Checkbox
        id={id}
        checked={checked}
        onCheckedChange={(checked) => onCheckedChange(checked === true)}
      />
      <Label htmlFor={id} className="cursor-pointer text-sm font-normal text-muted-foreground">
        {label}
      </Label>
    </div>
  );
}

export default RememberMeCheckbox;
